// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"647":"0d449256","914":"cc6765ac"}[chunkId] + ".js";
};